<template>
  <l-polygon 
    :lat-lngs="boundary" 
    :color="boundary.color"
    @click="onClick"
    >
    <l-popup>
      <span v-html="popup"></span>
    </l-popup>
  </l-polygon>
</template>

<script>
import { LPolygon, LPopup, LTooltip } from "vue2-leaflet";

export default {
  name: "BasePolygon",
  components: {
    LPolygon,
    LPopup,
    LTooltip,
  },
  props: {
    // LMarker propertise
    boundary: {
      type: [Object, Array],
      required: true
    },
    popup: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  }
}
</script>

<style>
</style>
